// ** Third Party Components
import {Download, Eye, Info} from 'react-feather'
import React from "react";
import { useDispatch } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import toast from 'react-hot-toast'
import { downloadInvoiceJSON, downloadInvoices } from '../store'

// ** Table Common Column

const documentsType = {
  "01": 'Factura',
  "03": 'Comprobante de Crédito Fiscal',
  "04": 'Nota de Remisión',
  "05": 'Nota de Crédito',
  "06": 'Nota de Débito',
  "07": 'Comprobante de retención',
  "08": 'Comprobante de liquidación',
  "09": 'Doc. Contable de liquidación',
  "11": 'Facturas de exportación',
  "14": 'Factura de sujeto excluido',
  "15": 'Comprobante de donación',
}

const CustomActions = ({row}) => {

  const handleDownloadPDF = (pdf, fileName) => {
    // descargar el archivo pdf que viene en el payload, como PDF %PDF-1.5, pero no es base64
    const url = window.URL.createObjectURL(new Blob([pdf], { type: 'application/pdf' }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.pdf`)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(url)

  }

  const handleDownloadJSON = (json, fileName) => {
    // descargar el archivo json que viene en el payload, como JSON {"id": "123", "name": "test"}
    const url = window.URL.createObjectURL(new Blob([json], { type: 'application/json' }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.json`)
    document.body.appendChild(link)
    link.click()

    window.URL.revokeObjectURL(url)
  }

  const [pending, setPending] = React.useState(false)
  const dispatch = useDispatch()

  const handleDownload = () => {
    console.log(row)
    setPending(true)
    dispatch(downloadInvoices(row)).then(response => {
      // console.log(response)
      setPending(false)
      if (response.error) return toast.error('Error al descargar el archivo')
      if (response.payload.error) return toast.error(response.payload.payload.rubridocTransactionStatusMsj)
      handleDownloadPDF(response.payload, row.generationCode)
    })
    .then(() => {
      dispatch(downloadInvoiceJSON(row)).then(response => {
        // console.log(response)
        if (response.error) return
        if (response.payload.error) return
        handleDownloadJSON(response.payload, row.generationCode)
      })
    })
    .catch(err => {
      // console.log(err)
      setPending(false)
    })
  }
  return (
    <div className='d-flex align-items-center justify-content-center gap-1'>
      {row.generationCode ? (
        <>
          {!pending && <Button size='sm' outline className='cursor-pointer' onClick={handleDownload}>
            <Download size={18} />
          </Button>
          }
          {pending && <Spinner size={18} color='info'/>}
        </>
      ) : (
        <Button size='sm' outline className='cursor-pointer' onClick={() => toast.error("Solicite este documento a Soporte Rubridoc", {
          icon: "🔒",
          style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
          }
        })  }>
          <Info size={18} />
        </Button>
      )}
    </div>
  )

}

export const columns  = () => [
  {
    name: 'ID',
    width: '5%',
    // center: true,
    selector: row => row.id,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.id}
      </div>
    )
  },
  {
    name: 'Tipo documento',
    width: '10%',
    // center: true,
    sortable: true,
    selector: row => documentsType[row?.dteType] || 'N/A',
  },
  // {
  //   name: 'Documento',
  //   width: '10%',
    // center: true,
  //   sortable: true,
  //   selector: row => row.dui || row.nit || row.nrc || 'N/A',
  // },
  {
    name: 'Nombre de Cliente',
    width: '15%',
    sortable: true,
    // center: true,
    selector: row => row.receiverName
  },
  {
    name: 'Fecha de emisión',
    width: '10%',
    // center: true,
    sortable: true,
    selector: row => (row.emissionDate ? new Date(row.emissionDate).toLocaleDateString() : 'N/A'),
  },
  {
    name: 'Correo del Cliente',
    width: '15%',
    // center: true,
    sortable: true,
    selector: row => row.receiverEmail,
  },
  {
    name: 'Tipo de documento identidad',
    width: '15%',
    // center: true,
    selector: row => (row.dui ? 'DUI' : row.nit ? 'NIT' : row.nrc ? 'NRC' : 'N/A'),
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {(row.dui ? 'DUI' : row.nit ? 'NIT' : row.nrc ? 'NRC' : 'N/A')}
      </div>
    )
  },
  {
    name: 'N° DOC. de identidad del cliente',
    width: '15%',
    // center: true,
    sortable: true,
    selector: row => row.dui || row.nit || row.nrc || 'N/A',
  },
  {
    name: 'Celular',
    width: '10%',
    // center: true,
    sortable: true,
    selector: row => row.receiverPhoneNumber,
  },
  {
    name: 'Acciones',
    width: '5%',
    // center: true,
    selector: '',
    cell: row => (<CustomActions row={row} />)
  },
]
